import moment from 'moment';

export const formatDisplayedDateTime = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '--';
  const parsed = moment(dateStr);
  return parsed.isValid() ? parsed.format('LLLL') : dateStr;
};

export const formatDisplayedDateTimeUtc = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '--';
  const parsed = moment.utc(dateStr);
  return parsed.isValid() ? parsed.format('LLLL') : dateStr;
};

export const formatDisplayedDate = (dateStr: string | Date | null | undefined): string | null => {
  if (!dateStr) return null;
  const d = dateStr instanceof Date ? dateStr : new Date(dateStr);
  return d.toLocaleString('default', { month: 'long' }) + ' ' + d.getDate() + ', ' + d.getFullYear();
};
